<template>
  <div class="t-button u-cursor-pointer u-center" :class="{'t-button--ghost': ghost,'t-button--gradient': hasGradient, 't-button--blue': blue, 't-button--gradient-border' : hasGradientBorder, 't-button--gradient-border--orange' : isBorderOrange, 't-button--little' : icon}" @click="$emit('click')">

    <svg v-if="hasGradientBorder" xmlns="http://www.w3.org/2000/svg" class="u-wrapper-panel">
      <defs>
        <linearGradient v-if="isBorderOrange" id="Gradient" x1="0" x2="100" y1="0" y2="0" gradientUnits="userSpaceOnUse">
         <stop stop-color="#FF77BC" offset="0"/>
         <stop stop-color="#FF9835" offset="1"/>
        </linearGradient>
        <linearGradient v-else id="Gradient" x1="0" x2="100" y1="0" y2="0" gradientUnits="userSpaceOnUse">
         <stop stop-color="#8EF3FF" offset="0"/>
         <stop stop-color="#FF9834" offset="0.5"/>
         <stop stop-color="#FF1CE2" offset="1"/>
        </linearGradient>
       </defs>
      <rect x="0.5" y="0.5" height="100%" width="100%" style="width:calc(100% - 1px);height:calc(100% - 1px)" rx="25" ry="30" stroke-width="1" fill="transparent" stroke="url(#Gradient)"/>
    </svg>

    <span v-if="url === ''" class="u-relative" :class="{'u-flex u-center u-middle':icon, 'u-orange' : isBorderOrange}">
      <slot/>
    </span>
    <a v-else :href="url" target="_blank" class="u-relative">
      <slot/>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    hasGradientBorder: {
      type: Boolean,
      default: false
    },
    isBorderOrange: {
      type: Boolean,
      default: false
    },
    hasGradient: {
      type: Boolean,
      default: false
    },
    ghost: {
      type: Boolean,
      default: false
    },
    blue: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.t-button
  position relative
  padding: $spacings.sm $spacings.md
  color: $colors.white
  border-radius: 100px
  
  &--little
    padding 12px 30px
    
  &--ghost:before
    background transparent !important
    border solid 2px $colors.white
    
  &--gradient-border
    &:before
      content none!important
  
  &--gradient
    background $gradients.pink-orange

  &:before
    content ''
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    border-radius 40px
    background url('/images/gradient.jpg')
    background-size 100% 100%
    
  &--blue:before
    background $colors.blue

</style>